import auth from './auth';
import assets from './assets';

import crf from './crf';

import equipment from './equipment';
import admin from './admin';
import api_key from './api_key';

import location from './location';

import report from './report';


export default {
	auth,
	assets,
	crf,
	equipment,
	admin,
	location,
	api_key,
	report

};
